import { Component, Input } from '@angular/core';
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.css']
})
export class InfoCardComponent {
  @Input() title: any = '';
  @Input() cor: string = '';
  @Input() value: any = 0;
  @Input() progress: number | null = null;
  @Input() footerText: string = '';
  @Input() footerIcon: string = '';
  @Input() backgroundIcon: string = 'info';
  @Input() valuePrefixo: string ='';
  @Input() valueSufixo: string = '';

    // novo input para o formato
  @Input() valueFormat: string = '1.2-2'; // padrão duas casas decimais

  displayedValue: number = 0;

  ngOnInit() {
    this.animateValue();
  }

  ngOnChanges() {
    this.displayedValue = 0; // Reinicia o valor exibido quando a entrada muda
    this.animateValue(); // Inicia a animação novamente
  }

  animateValue() {
    const duration = 2000; // duração total da animação em milissegundos
    const steps = 60; // número total de incrementos
    const intervalDuration = duration / steps;
    const increment = this.value / steps;

    interval(intervalDuration)
      .pipe(takeWhile(() => this.displayedValue < this.value))
      .subscribe(() => {
        this.displayedValue += increment;
        if (this.displayedValue > this.value) {
          this.displayedValue = this.value;
        }
      });
  }

}
